import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import { vMaska } from 'maska/vue'

import App from './App.vue'
import router from './router'
import { pinia } from './stores'
import { useInitStore } from './stores/init'

import sdk from '@/components/registration.sdk'
import freshchat from '@/components/freshchat'
import sentry from '@/components/sentry'
import VSelect from '@/components/VSelect'

const app = createApp(App)
const head = createHead()

app.use(pinia)

app.use(sdk)
app.use(freshchat)
app.use(sentry, { router })
app.use(head)
app.directive('maska', vMaska)
app.use(router)
app.component('VSelect', VSelect)

useInitStore(pinia)
  .initApp()
  .then(() => app.mount('#app'))
  .catch((error) => {
    console.error('App failed:', error)
    app.mount('#app')
  })

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  window.location.reload()
})
